import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private _sessionTime = environment.sessionTimeout * 60;
  // private apiUrl: string = environment.api;
  // public permissionsLoaded$ = new Subject();
  // public resCenterChanged$ = new Subject<boolean>();
  private _InternetConnection: string = 'Tecsa-internet-status';
  private _isLogin: string = 'Tecsa-isLogin';
  private _AppOpend: string = 'Tecsa-AppOpend';
  private _appVersion: string = 'Warehouse-appVersion';
  constructor() { }

  get netConnection(): boolean {
    return <boolean>this.getData(this._InternetConnection);
  }

  set netConnection(v: boolean) {
    this.setData(this._InternetConnection, v);
  }

  public get User(): any {
    return JSON.parse(localStorage.getItem('Tecsa-user-details'));
  }

  public set User(v: any) {
    this._sessionTime = environment.sessionTimeout * 60;
    localStorage.setItem('Tecsa-user-details', JSON.stringify(v))
  }

  public get Email(): any {
    return JSON.parse(localStorage.getItem('Tecsa-email-details'));
  }

  public set Email(v: any) {
    localStorage.setItem('Tecsa-email-details', JSON.stringify(v))
  }

  public get ApiEnv(): any {
    return JSON.parse(localStorage.getItem('Tecsa-api-details'));
  }

  public set ApiEnv(v: any) {
    localStorage.setItem('Tecsa-api-details', JSON.stringify(v))
  }

  public get Company(): any {
    return JSON.parse(localStorage.getItem('Tecsa-comapny'));
  }

  public set Company(v: any) {
    localStorage.setItem('Tecsa-comapny', JSON.stringify(v))
  }

  public get accessToken(): any {
    return localStorage.getItem('access-token');
  }

  public set accessToken(v: any) {
    localStorage.setItem('access-token', v)
  }

  public get CompanyName(): any {
    return JSON.parse(localStorage.getItem('Tecsa-comapny-name'));
  }

  public set CompanyName(v: any) {
    localStorage.setItem('Tecsa-comapny-name', JSON.stringify(v))
  }
  get appVer(): string {
    return <string>this.getData(this._appVersion);
  }
  set appVer(v: string) {
    this.setData(this._appVersion, v);
  }


  get isLogin(): boolean {
    return <boolean>this.getData(this._isLogin);
  }

  set isLogin(v: boolean) {
    this.setData(this._isLogin, v);
  }

  get AppOpend(): boolean {
    return <boolean>this.getData(this._AppOpend);
  }

  set AppOpend(v: boolean) {
    this.setData(this._AppOpend, v);
  }

  public get licensePermission(): boolean {
    return JSON.parse(localStorage.getItem('warehouse-licensePermission'));
  }

  public set licensePermission(v: boolean) {
    localStorage.setItem('warehouse-licensePermission', JSON.stringify(v))
  }
  public get IP(): any {
    return JSON.parse(localStorage.getItem('warehouse-user-ip'));
  }

  public set IP(v: any) {
    localStorage.setItem('warehouse-user-ip', JSON.stringify(v))
  }

  public get UserLiseceLoginIfo(): any {
    return JSON.parse(localStorage.getItem('warehouse-Lisence-details'));
  }

  public set UserLiseceLoginIfo(v: any) {
    localStorage.setItem('warehouse-Lisence-details', JSON.stringify(v))
  }

  public clearData() {
    this.ApiEnv = null;
    this.User = null;
    this.Email = null;
    this.Company = null;
    this.CompanyName = null;
    this.accessToken = null;

    localStorage.removeItem(this._InternetConnection);
    localStorage.removeItem(this._isLogin);
    localStorage.removeItem(this._AppOpend);
    localStorage.removeItem(this._appVersion);
    localStorage.removeItem('warehouse-Lisence-details');
    localStorage.removeItem('access-token');
  }


  public setData(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getData(key: string) {
    return JSON.parse(localStorage.getItem(key));
  }

}
